import React from "react";

function MusicschoolIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <g clipPath="url(#clip0_899_1340)">
        <mask
          id="mask0_899_1340"
          style={{ maskType: "luminance" }}
          width="16"
          height="16"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
        >
          <path fill="#fff" d="M0 0h16v16H0V0z"></path>
        </mask>
        <g mask="url(#mask0_899_1340)">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M6.5 11a1.5 1.5 0 010-3c.828 0 1.472.672 1.472 1.5A1.46 1.46 0 016.5 11zm9.21-9.78l-.928-.927a1 1 0 00-1.414 0l-1.445 1.45a1.098 1.098 0 00-.268.43l-.381 1.14L8.89 5.697a3.496 3.496 0 00-1.253-.6c-1.044-.24-2.094-.025-2.81.688a2.647 2.647 0 00-.631 1.047c-.188.578-.725 1.022-1.318 1.075-.738.075-1.43.36-1.957.89-1.426 1.422-1.168 3.985.566 5.72 1.73 1.73 4.295 1.984 5.717.562a3.28 3.28 0 00.89-1.96c.055-.586.495-1.13 1.078-1.318.39-.12.75-.34 1.043-.633.715-.714.93-1.761.66-2.805-.106-.457-.325-.874-.598-1.253l2.383-2.383 1.142-.38c.16-.055.309-.148.43-.27l1.449-1.446a.972.972 0 00.028-1.412z"
            clipRule="evenodd"
          ></path>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_899_1340">
          <path fill="#fff" d="M0 0H16V16H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.memo(MusicschoolIcon);
